export default "__VITE_ASSET__DN61em9H__"